<script>
import { EventBus } from '@/app'

export default {
    data() {
        return {
            allCategories: []
        }
    },

    methods: {
        evaluateCategories() {
            const categories = this.$page.props.request.query.category
                ? [this.$page.props.request.query.category]
                : this.$page.props.request.query.categories ?? []

            this.$set(this, 'allCategories', [])

            categories.forEach(alias => this.addCategory(
                this.$models.$category.flattenTree().find(c => c.alias == alias)
            ))
        },

        clickCategory(category) {
            EventBus.$emit('root', 'busy.open')

            if(this.allCategories.includes(category.alias)) {
                this.removeCategory(category)

                if(category.parent_id) {
                    this.addCategory(
                        this.$models.$category.flattenTree().find(c => c.id == category.parent_id)
                    )

                    this.allCategories = _.uniq(this.allCategories)
                }

            } else {
                this.addCategory(category)
            }

            let categories = []

            this.allCategories.forEach(
                alias => categories.push(this.$models.$category.flattenTree().find(category => category.alias == alias))
            )

            let deletables = categories.map(category => category.parent_id)

            categories = categories.filter(c => ! deletables.includes(c.id)).map(c => c.alias)

            this.$inertia.get(route('pages.web.catalog'), {categories: categories})
        },

        addCategory(category) {
            this.allCategories.push(category.alias)

            if(category.parent_id) {
                this.addCategory(
                    this.$models.$category.flattenTree().find(c => c.id == category.parent_id)
                )
            }

            this.allCategories = _.uniq(this.allCategories)
        },

        removeCategory(category) {
            _.remove(this.allCategories, alias => alias == category.alias)

            category.children.forEach(
                c => this.removeCategory(c)
            )

            this.allCategories = _.uniq(this.allCategories)
        }
    }
}
</script>